import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { TextField } from "@mui/material";
import { Grid } from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import _ from "underscore";
import "./style.css";
import { cloaseDonePopup, EditProductTableError, EditProductTableStart, EditProductTableSuccess, openErrorDialog } from "../../../Redux/Actions/InputData";
import { putRequest } from "../../../Services/AxiosConfiguration";
import { API_BASE_URL, MEDIUM_NUTRITION_EDIT_OEE_CPT_TABLE_API } from "../../../Utils/Config";
import { useState } from "react";
import { useForm } from "react-hook-form";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function EditModal(props: any) {
    const { editedData } = props;
    const dispatch: any = useDispatch();
    const [isDone, setIsDone] = useState(false);

    const handleCloseDonePopup = () => {
        setIsDone(false);
        dispatch(cloaseDonePopup());
    };

    // const validationSchema = Yup.object().shape({
    //     lead_Time: Yup.string().required('Lead Time is required'),
    //     variable_Cost: Yup.string().required('Variable Cost is required'),
    //     inbound_Transportation_cost: Yup.string().required('InBound Transportation Cost is required'),
    //     lat: Yup.string().required('Latitude is required'),
    //     long: Yup.string().required('Longitude is required')
    // });

    // const { register, control, handleSubmit, formState: { errors } } = useForm({
    //     resolver: yupResolver(validationSchema)
    // });

    const validationSchema = Yup.object().shape({
        oee: Yup.string().required('OEE Cost is required')
        ,
        conversion_Cost_per_Tonne: Yup.string().required('Conversion Cost CPT is required')
    });

    const { register, control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = () => {
        // const requestParam = { "table": "Sourcing_data", "id": data.id, "values": {"Variable Cost (per unit)": data["Variable Cost (per unit)"], "Lead Time (in Hrs)": data["Lead Time (in Hrs)"], "Inbound Transportation cost": data["Inbound Transportation cost"] ,"Lat": data["Lat "], "Long": data.Long}};
        dispatch(EditProductTableStart());
        const urls = API_BASE_URL + MEDIUM_NUTRITION_EDIT_OEE_CPT_TABLE_API;
        const header = {accept: "application/json", "Content-Type": "application/json"};
        putRequest(urls, editedData, header, {}).then((response) => {
            if (response.status === 200) {
                dispatch(EditProductTableSuccess(response.data));
            }
        }).catch((error) => {
            dispatch(openErrorDialog(error));
            dispatch(EditProductTableError(error));
        });
        setTimeout(() => {
            props.onClose();
        }, 200);
    };
    return (
      <>
        <BootstrapDialog
          className="edit-dialog"
          onClose={props.onClose}
          aria-labelledby="customized-dialog-title"
          open={props.isOpen}
        >
          <div className="modal-header">
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h3>{props.headerName}</h3>
                <span className="title-note">Edit table content</span>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <CancelIcon className="cancel-icon" onClick={props.onClose} />
              </Grid>
            </Grid>
          </div>
          <div>
            <DialogContent className="modal-body">
              <form>
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6} md={6} lg={6}>
                    <TextField
                      type="text"
                      label="Factory Code"
                      variant="outlined"
                      defaultValue={editedData.factory_Code}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6} md={6} lg={6}>
                    <TextField
                      type="text"
                      label="Factory"
                      variant="outlined"
                      defaultValue={editedData.factory}
                      disabled
                    />
                  </Grid>
                </Grid>

                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Format"
                      variant="outlined"
                      defaultValue={editedData.format}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Cascade"
                      variant="outlined"
                      defaultValue={editedData.cascade}
                      disabled
                    />
                  </Grid>
                </Grid>

          
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Line"
                      variant="outlined"
                      defaultValue={editedData.line}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Pack"
                      variant="outlined"
                      defaultValue={editedData.pack}
                      disabled
                    />
                  </Grid>
                  {/* <Grid container item sm={6}>
                                    <TextField type="text" label="pack" variant="outlined" {...register("lead_Time")} required error={errors.lead_Time ? true : false} defaultValue={editedData.lead_Time} onChange={(e) => editedData.lead_Time = e.target.value} />
                                </Grid> */}
                </Grid>
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Basepack"
                      variant="outlined"
                      defaultValue={editedData.basepack}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Product"
                      variant="outlined"
                      defaultValue={editedData.product}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Basepack Code"
                      variant="outlined"
                      defaultValue={editedData.basepack_Code}
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Time Period"
                      variant="outlined"
                      defaultValue={editedData.time_period}
                      disabled
                    />
                  </Grid>
                  <Grid container item sm={6}>
                    <TextField
                      type="text"
                      label="Volume"
                      variant="outlined"
                      defaultValue={editedData.volume}
                      disabled
                    />
                  </Grid>
                </Grid>
               
              
            
                <Grid direction="row" container spacing={2} mb={2}>
                
                  <Grid container item sm={6} lg={6}>
                    <TextField
                    onKeyDown={(evt) => ["e", "E", "+"].includes(evt.key) && evt.preventDefault()}
                      type="number"
                      label="OEE"
                      variant="outlined"
                      {...register("oee")}
                      required
                      error={errors.oee ? true : false}
                      defaultValue={editedData.oee}
                      onChange={(e) =>
                        (editedData.oee = e.target.value)
                      }
                    />
                  </Grid>
                  <Grid container item sm={6} >
                    <TextField
                    onKeyDown={(evt) => ["e", "E", "+"].includes(evt.key) && evt.preventDefault()}
                      type="number"
                      label="conversion_Cost_per_Tonne"
                      variant="outlined"
                      {...register("conversion_Cost_per_Tonne")}
                      required
                      error={errors.conversion_Cost_per_Tonne ? true : false}
                      defaultValue={editedData.conversion_Cost_per_Tonne}
                      onChange={(e) =>
                        (editedData.conversion_Cost_per_Tonne = e.target.value)
                      }
                    />
                  </Grid>
                </Grid>
                <Grid direction="row" container spacing={2} mb={2}>
                  <Grid container item sm={6}>
                    <div className="error-msg">
                      {errors.oee ? "Invalid OEE Cost" : false}
                    </div>
                  </Grid>
                    <Grid container item sm={6}>
                    <div className="error-msg">
                      {errors.conversion_Cost_per_Tonne
                        ? " Invalid conversion Cost"
                        : false}
                    </div>
                  </Grid>
                  </Grid>
           
              </form>
            </DialogContent>
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={props.onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="save"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save Table Row
                </Button>
                {/* <Button variant="contained" className="save" onClick={(e) => {handleSave(editedData, props);}}>Save Table Row</Button> */}
              </div>
            </DialogActions>
          </div>
        </BootstrapDialog>
      </>
    );
}

export default EditModal;
